/**
 * @generated SignedSource<<8903b50c56bdd675c0d9bdff751c676e>>
 * @relayHash 485931b6b679d4d6706715c7ef04e1cd
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 485931b6b679d4d6706715c7ef04e1cd

import { ConcreteRequest } from 'relay-runtime';
export type useDePreparationAdditionalInformationQuery$variables = {
  pharmaceuticalCentralNumber: string;
};
export type useDePreparationAdditionalInformationQuery$data = {
  readonly de_preparationInformationLetter: {
    readonly letterList: ReadonlyArray<{
      readonly document: string | null;
    }>;
    readonly letterNumber: number;
  };
  readonly de_preparationSpecialistInformation: {
    readonly informationTexts: ReadonlyArray<{
      readonly decodedText: string;
      readonly textId: number;
      readonly title: string;
    }>;
    readonly name: string;
  } | null;
};
export type useDePreparationAdditionalInformationQuery = {
  response: useDePreparationAdditionalInformationQuery$data;
  variables: useDePreparationAdditionalInformationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pharmaceuticalCentralNumber"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pharmaceuticalCentralNumber",
    "variableName": "pharmaceuticalCentralNumber"
  }
],
v2 = [
  {
    "alias": null,
    "args": (v1/*:: as any*/),
    "concreteType": "PreparationSpecialistInformation",
    "kind": "LinkedField",
    "name": "de_preparationSpecialistInformation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SpecialistInformationText",
        "kind": "LinkedField",
        "name": "informationTexts",
        "plural": true,
        "selections": [
          {
            "alias": "textId",
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "decodedText",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*:: as any*/),
    "concreteType": "PreparationInformationLetter",
    "kind": "LinkedField",
    "name": "de_preparationInformationLetter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "letterNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PreparationInformationLetterDetail",
        "kind": "LinkedField",
        "name": "letterList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "document",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDePreparationAdditionalInformationQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDePreparationAdditionalInformationQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "485931b6b679d4d6706715c7ef04e1cd",
    "metadata": {},
    "name": "useDePreparationAdditionalInformationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fff85bda4393c20bb6f6cf7547c9f05f";

export default node;
